import requests from './request';

// 地图显示坐标数据
export function queryBuildingInfoByTypeIds(query) {
    return requests({
        url: '/large-screen/queryBuildingInfoByTypeIds?buildingTypeIds=' + query,
        method: 'get',
        headers: {
            // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
    })
}
// 高风险地区划分
export function queryAreaInfoByAreaInfoIds(query) {
    return requests({
        url: '/large-screen/queryAreaInfoByAreaInfoIds?areaInfoIds=' + query,
        method: 'get',
        headers: {
            // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
    })
}
// 图层管理
export function queryMapLayerData() {
    return requests({
        url: '/large-screen/queryMapLayerData',
        method: 'get',
        headers: {
            // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
    })
}
// 企业主体的部分信息
export function queryBuildingInfoWithSurveyRecored(query) {
    return requests({
        url: '/large-screen/queryBuildingInfoWithSurveyRecored?buildingInfoId=' + query,
        method: 'get',
        headers: {
            // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
    })
}